import request from "./api.js";
//请求根路径（ps：就是所有请求中，地址中前面不变的那一部分）

// 正式地址
export const BaseUrl = "https://sichuan-university-api.leleu.cn";
// export const BaseUrl = "https://ticket.sxd.cn"; //王洲本地
// export const BaseUrl = "http://192.168.10.172:8002"; //仇仇本地
// export const BaseUrl = "http://192.168.11.140:8002"; //刘聪本地
//系统访问地址（主要用于登录过期时回退页面使用了，一般无需修改）
// export const AccessUrl = 'https://sichuan-university-guanwang-view.leleu.cn/'
// 商户号
export const merchantNo = "E888888880";

//获取团队须知
export function teamConfigList(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/teamConfigList`,
            method: "get",
            data: param,
        },
    });
}

//二维码
export function getSmallAppLoginQrCode(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/pass/getSmallAppLoginQrCode`,
            method: "post",
            data: param,
        },
    });
}
export function getLoginQrCodeStatus(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api//app/clientHelper/pass/getLoginQrCodeStatus`,
            method: "post",
            data: param,
        },
    });
}

// 登录
export function login(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/pass/loginForgw`,
            method: "post",
            data: param,
        },
    });
}
// 登录
export function officialWebsiteLogin(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/pass/officialWebsiteLogin`,
            method: "post",
            data: param,
        },
    });
}
// 登录验证码
export function sendLoginCode(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/pass/sendLoginCode`,
            method: "post",
            data: param,
        },
    });
}
// 退出
export function officialWebsiteLogout(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/officialWebsiteLogout`,
            method: "post",
            data: param,
        },
    });
}
// 获取门票配置
export function getTicketConfig(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/getTicketConfig?` + param,
            method: "get",
        },
    });
}
// 获取预约时间
export function getTimeSlotsLimit(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/getTimeSlotsLimit`,
            method: "post",
            data: param,
        },
    });
}
// 获取团队可预约天
export function AppointmentDay(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/appointmentDay`,
            method: "get",
            params: param,
        },
    });
}
// 获取产品信息
export function getProductList(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/getProductList`,
            method: "get",
            params: param,
        },
    });
}

// 下载团队预约参观名单模板
export function downModel(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/pass/downModel/v1`,
            method: "get",
            params: param,
        },
    });
}

// 创建订单
export function createOrder(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/v1/createOrder`,
            method: "post",
            data: param,
        },
    });
}

//获取订单详情
export function getOrderDetail(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/orderDetail`,
            method: "get",
            params: param,
        },
    });
}

// 取消订单
export function CancelOrder(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/cancelOrder`,
            method: "post",
            data: param,
        },
    });
}

// 团队认证
export function TeamAttestation(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/teamManage/save`,
            method: "post",
            data: param,
        },
    });
}

// 重新提交团队认证
export function UpdateTeamAttestation(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/teamManage/update`,
            method: "post",
            data: param,
        },
    });
}

// 团队认证详情
export function getTeamAttestationDetail(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/teamManage/checkIsTeam`,
            method: "get",
            params: param,
        },
    });
}

// 获取订单列表
export function getOrderList(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/orderListForOfficial`,
            method: "get",
            params: param,
        },
    });
}

export function checkToken(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/checkToken`,
            method: "get",
            params: param,
        },
    });
}

// 获取待开票列表/开票历史列表
export function getInvoiceList(param, tab) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/${
                tab == 1 ? "invoiceHistory" : "waitInvoiceList"
            }`,
            method: "get",
            params: param,
        },
    });
}

// 提交开票信息
export function SaveInvoiceOrder(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/saveInvoiceOrder`,
            method: "post",
            data: param,
        },
    });
}

// 获取开票详情
export function getInvoiceDetail(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/invoiceDetail`,
            method: "get",
            params: param,
        },
    });
}

// 发票申请重开
export function resetOpenInvoice(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/resetOpenInvoice`,
            method: "post",
            data: param,
        },
    });
}
//继续支付
export function doKeepPaying(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/doKeepPaying`,
            method: "post",
            data: param,
        },
    });
}

// 获取团队预约订单游客列表
export function getCustomerUserList(param, id) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/getCustomerUserList`,
            method: "get",
            params: param,
        },
    });
}

// 发票通过名称模糊搜索公司名
export function getCompanyName(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/prefixQuery`,
            method: "get",
            params: param,
        },
    });
}

// 发票通过名称模糊搜索税号
export function getCompanyCode(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/queryNameAndTaxByCode`,
            method: "get",
            params: param,
        },
    });
}

// 检查是否是团队
export function checkIsTeam(param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/teamManage/checkIsTeam`,
            method: "get",
            params: param,
        },
    });
}

// 验证身份证和姓名是否对应
export function realNameAuth(name, idNo, param) {
    return request({
        data: {
            url: `${BaseUrl}/api-api/app/clientHelper/realNameAuth?name=${name}&idNo=${idNo}`,
            method: "post",
            data: param,
        },
    });
}
